export default {
  GET_ALL_APPLICATION_INSTANCE: 'getAllApplicationInstance',
  SAVE_APPLICATION_INSTANCE: 'saveApplicationInstance',
  DELETE_APPLICATION_INSTANCE: 'deleteApplicationInstance',
  GET_USER_APP_INSTANCES: 'getUserAppInstances',
}